export const EstadoSms = Object.freeze({
    PENDIENTE: "PENDIENTE",
    ENVIADO: "ENVIADO",
    ERROR: "ERROR"
});
